document.addEventListener('DOMContentLoaded', function () {

  /* ---- reveal on scroll ---- */
  const io = new IntersectionObserver(es => es.forEach(e => e.isIntersecting && e.target.classList.add('in')), { threshold: .06 });
  document.querySelectorAll('.ch-rv').forEach(el => io.observe(el));

  /* ---- animated counters ---- */
  const ci = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    ci.unobserve(e.target);
    const el = e.target, to = +el.dataset.count, suf = el.dataset.suffix || '', t0 = performance.now();
    const tick = t => {
      const k = Math.min((t - t0) / 1400, 1);
      el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))) + (k === 1 ? suf : '');
      if (k < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }), { threshold: .5 });
document.querySelectorAll('.ch-counter').forEach(el => ci.observe(el));

  /* ---- category showcase auto-rotator ---- */
  document.querySelectorAll('[data-ch-category-showcase]').forEach(root => {
    const items = [...root.querySelectorAll('.ch-cindex li')];
    const figs = [...root.querySelectorAll('.ch-cstage figure')];
    const nameEl = root.querySelector('[data-cs-name]');
    const countEl = root.querySelector('[data-cs-count]');
    const linkEl = root.querySelector('[data-cs-link]');
    const bar = root.querySelector('.ch-cbar');
    if (!items.length) return;
    let idx = 0, start;
    function setActive(i) {
      idx = i;
      items.forEach((li, n) => li.classList.toggle('on', n === i));
      figs.forEach((f, n) => f.classList.toggle('on', n === i));
      const li = items[i];
      if (nameEl) nameEl.textContent = li.dataset.name;
      if (countEl) countEl.textContent = li.dataset.count;
      if (linkEl) linkEl.href = li.dataset.url;
      start = undefined;
    }
    items.forEach((li, i) => li.addEventListener('pointerover', () => setActive(i)));
    function loop(t) {
      if (start === undefined) start = t;
      const k = Math.min((t - start) / 4200, 1);
      if (bar) bar.style.width = (k * 100) + '%';
      if (k === 1) setActive((idx + 1) % items.length);
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
  });

    /* ---- product tabs (server-rendered panels, JS just toggles) ---- */
  document.querySelectorAll('[data-ch-tabs]').forEach(root => {
    const tabs = root.querySelectorAll('.ch-tab');
    const panels = root.querySelectorAll('.ch-tabpanel');
    tabs.forEach(tab => tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('on'));
      panels.forEach(p => p.classList.remove('on'));
      tab.classList.add('on');
      const panel = root.querySelector('.ch-tabpanel[data-panel="' + tab.dataset.tab + '"]');
      if (panel) panel.classList.add('on');
    }));
  });



  /* ---- horizontal rail: drag + arrow buttons ---- */
document.querySelectorAll('.ch-rail').forEach((rail, i) => {
    const prev = document.querySelectorAll('[data-rail-prev]')[i];
    const next = document.querySelectorAll('[data-rail-next]')[i];

    if (next) {
        next.addEventListener('click', () => {
            rail.scrollBy({ left: 360, behavior: 'smooth' });
        });
    }

    if (prev) {
        prev.addEventListener('click', () => {
            rail.scrollBy({ left: -360, behavior: 'smooth' });
        });
    }
});

  /* ---- quick add to cart (AJAX) ---- */
  document.querySelectorAll('[data-ch-quick-add]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const id = btn.dataset.variantId;
      if (!id) { window.location.href = btn.dataset.productUrl; return; }
      const original = btn.textContent;
      btn.textContent = 'Adding...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        });
        if (res.ok) {
          btn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(() => { btn.textContent = original; }, 1600);
        } else {
          btn.textContent = 'Sold out';
          setTimeout(() => { btn.textContent = original; }, 1600);
        }
      } catch (err) {
        window.location.href = btn.dataset.productUrl;
      }
    });
  });

  /* ---- parallax banners ---- */
  const px = [...document.querySelectorAll('.ch-parallax')];
  if (px.length) {
    window.addEventListener('scroll', () => {
      px.forEach(p => {
        const r = p.getBoundingClientRect();
        if (r.bottom > 0 && r.top < innerHeight) {
          p.style.transform = 'translateY(' + (((r.top + r.height / 2 - innerHeight / 2) / innerHeight) * -30) + 'px)';
        }
      });
    }, { passive: true });
  }
});
